import { atom, useRecoilState } from 'recoil';

export interface AuthState {
  token?: string;
}

export const authState = atom<AuthState>({
  key: 'authState',
  default: {},
});

export const useAuthState = () => {
  const [state, setState] = useRecoilState(authState);
  return { ...state, setState };
};
